import {TableSettings} from '../../interfaces/table-setting.interface';
import {PageableDTO} from '../../openapi/fakturierung-openapi';


export enum AbsenderColumn {
  Kundennummer = 'kundenNummer',
  Anrede = 'anrede',
  Titel = 'titel',
  NameVorname = 'nameVorname',
  Firma = 'firma',
  StrasseUndHausnummer = 'strasseUndHausnummer',
  Land = 'land',
  Plz = 'plz',
  Ort = 'adresse',
  Email = 'email',
  Besteuerungsform = 'besteuerungsform',
  UstNummer = 'ustNummer',
  Steuernummer = 'steuernummer',
  Kontoinhaber = 'kontoinhaber',
  Iban = 'iban',
  Actions = 'actions',
}

export interface KundeTableState {
  displayedIds: string[];
  tableSettings: TableSettings;
  pageableDto: PageableDTO;
  totalPages: number
  kundenLoaded: boolean;
}
